// 기본 설정 상수
const $WC = {
    localGovName: process.env.VUE_APP_LOCAL_GOV_NAME,               // 지자체 명
    localGovCode: process.env.VUE_APP_LOCAL_GOV_CODE,               // 지차체 코드
    localGovLatitude: process.env.VUE_APP_LOCAL_GOV_LATITUDE,       // 위도
    localGovLongitude: process.env.VUE_APP_LOCAL_GOV_LONGITUDE,     // 경도
    cp: process.env.BASE_URL,
    apiBaseURL: process.env.VUE_APP_APIBASEURL,
    geojsonPath: process.env.VUE_APP_GEOJSON_PATH,
    adGuCode: process.env.VUE_APP_AD_GU_CODE,                       // 구코드
    viewScale: Math.ceil(window.innerWidth / 1920),              // 사용자 view scale
    markerScale: (window.innerWidth / 1920) <= 1 ? 1 : (window.innerWidth / 1920) / 2,
    THREE_MIN_INTERVAL: 1000 * 60 * 3,
    FIVE_MIN_INTERVAL: 1000 * 60 * 5,
    TEN_MIN_INTERVAL: 1000 * 60 * 10,
    TEN_SEC_INTERVAL: 1000 * 10,
    FIVE_SEC_INTERVAL: 1000 * 5,
    SEVEN_SEC_INTERVAL: 1000 * 7,
    UNDEF: 'undefined',
};

// 자료 종류 번호
const $DKD = {
    SAFETY: 1027,                   // 재난안전
    SAFETY_HIST: 1028,              // 재난안전 진행내역
    SAFETYCENTER: 1050,             // 안전센터
    MEDICALFAC: 1089,               // 의료시설
    POLICE: 1049,                   // 경찰서
    ACCIDENT: 161,                  // 돌발
    AIR_GU: 1030,                   // 자치구 대기 정보
    AIR_HJD: 1031,                  // 행정동 대기 정보
    FINANCE_EXPENDITURE: 1138,      // 재정 세부사업별 예산현액 및 지출액자료관리
    WATER_QUALITY: 91,              // 수질 현황
    WATER_RESERVOIR: 443,           // 배수지 정보
    WATER_FAUCET: 1060,             // 수도 꼭지
    WATER_ROAD: 1061,               // 물길 정보
    INDICATOR: 1055,                // 구정현황
    COOPERATION: 376,               // 국장 중심 책임사업 (총괄)
    BUREAU_COOPERATION: 379,        // 국장 중심 책임사업 (협업 부서)
    PROMISE: 377,                   // 공약 사업
    GOVERNANCE_FOUND: 445,          // 지역 협치 기반 구축 (협치)
    GOVERNANCE_INNO: 446,           // 지역 사회 혁신 부문별 계획 실행 (협치)
    HJD_INFO: 440,                  // 행정동 정보
    POP_HJD_AGE: 401,               // 행정동 기준 연령별 인구 정보
    POP_DAY_AGE: 407,               // 자치구 기준 연령별 인구 정보
    POP_DISABLED: 1066,             // 행정동 기준 장애인 인구
    POP_PENSIONER: 1065,            // 행정동 기준 기초생활 수급자
    LIFE_POP_LOCAL: 1105,           // 생활인구 행정동별(내국인)
    LIFE_POP_SHORT: 1104,           // 생활인구 행정동별(단기체류 외국인)
    LIFE_POP_LONG: 1103,            // 생활인구 행정동별(장기체류 외국인)
    CULTURE: 1133,                  // 문화재
    TREKKING: 1134,                 // 둘레길
    CMC_LATEST: 1132,               // 상권 데이터 최종 년분기
    CMC_INDUSTRY_CD: 1116,          // 상권업종 코드
    CMC_SGG_SUMMARY: 1124,          // 시군구 업종 별 상권 개요
    CMS_HJD_SUMMARY: 1123,          // 행정동 업종 별 상권 개요
    CMS_ZONE_SUMMARY: 1126,         // 상권권역 업종 별 상권 개요
    CMS_ZONE_ALLEY: 1119,           // 골목 상권 GIS 정보
    CMS_ZONE_DEVLOP: 1120,          // 발달 상권 GIS 정보
    CMS_ZONE_TRDIT: 1121,           // 전통시장 상권 GIS 정보
    CMS_ZONE_TURSM: 1122,           // 관광특구 GIS 정보
    RESPONSE_CENTER: 1040,          // 응답소
    INTERNET_TV: 1067,              // 은평인터넷방송
    EUNPYUNG_WANT: 1056,            // 은평에바란다
    WEATHER_FORECAST: 46,           // 동녜 날씨 예보 정보
    WASTE_SEPARATING: 1139,         // 재활용정거장 내 분리배출 점검
    WASTE_QUANTITY: 1140,           // 1인당 생활폐기물 발생량
    WASTE_MIX: 1141,                // 재활용 혼합 배출 점검
    MOAMOA: 1167,                   // 모아모아 월별 수거량
    FINANCE_REVENUE: 1142,          // 재정 지방세 징수 현황
    HEALING_EAT: 1144,              // 둘레길 - 시장 먹거리
    HEALING_PLAY: 1145,             // 둘레길 - 명소
    HEALING_SEE: 1146,              // 둘레길 - 박물관, 미술관 등
    COVID_STATE: 1152,              // 코로나 현황(수치)
    COVID_VACCINATION: 1166,        // 코로나 백신 접족 현황
};

// 코드 그룹 상수 정의
const $GCD = {
    BUREAU: '402001',            // 실국 그룹 코드
    PROMISE_CAT: '402010',       // 공약 사업 분류 그룹 코드
    GOVERNANCE_CAT: '402020',    // 협치 사업 분류 그룹 코드
    FACILITY_CAT: '401001'       // 은평 생활지도 카테고리 그룹 코드
};

 // 코드 상수 정의
const $CD = {
    DEPT_EP: '31100000000',
    HEAD: '31100580000',        // 구청장
    SECOND_HEAD: '31100590000', // 부구청장
    BUREAU_GAMSA: '31100600000',    // 감사담당관
    BUREAU_HYUBCHI: '31102140000',  // 협치 담당관
    BUREAU_HONGBO: '31101500000',   // 홍보 담당관
    BUREAU_UIHOE: '31100980000',    // 의회사무국
    BUREAU_HANGJEONG: "31101940000", // 행정안전국
    BUREAU_JUMIN: "31101540000",    // 주민 복지국
    DEPT_HANGJEONG: '31102160000',  // 행정 지원과
    DEPT_TRAFFIC: '31101950000',  // 건설 교통국
    DEPT_ENVIR: '31101170000',      // 도시 환경국
    DEPT_SISUL: '31102270000',      // 시설 건립 추진단 제외
    TEAM_SECRETARY: '31102160050',  // 비서실
    TEAM_POLICY: '31102160100',     // 정책 보좌관
    GOVERNANCE_FOUND: 'governance_found',
    GOVERNANCE_INNO: 'governance_inno'
};

const $HJD = {
    '1138051000': '녹번동',
    '1138052000': '불광1동',
    '1138053000': '불광2동',
    '1138055100': '갈현1동',
    '1138055200': '갈현2동',
    '1138056000': '구산동',
    '1138057000': '대조동',
    '1138058000': '응암1동',
    '1138059000': '응암2동',
    '1138060000': '응암3동',
    '1138062500': '역촌동',
    '1138063100': '신사1동',
    '1138063200': '신사2동',
    '1138064000': '증산동',
    '1138065000': '수색동',
    '1138069000': '진관동',
};

// 네이버 지도 관련 상수
const $NM = {
    TILE_SIZE_SCALE: $WC.viewScale * 1.2,   // 네이버 지도 타일 사이즈 스케일
    ZOOM_LEVEL: 13,                         // 네이버 지도 줌 레벨
}

export {$WC, $DKD, $GCD, $CD, $HJD, $NM}
